import JuctionModal from 'components/Modals/JuctionModal';
import React, { useState } from 'react';

const Triangle = ({ imgSrc }) => {
  const [juctionModal, setJuctionModal] = useState(false);

  return (
    <>
      <div className="lg:container mx-auto px-6 lg:px-0">
        <img
          onClick={() => {
            setJuctionModal(true);
          }}
          className="img img-fluid w-full"
          src={imgSrc}
          alt=""
        />
      </div>

      <JuctionModal show={juctionModal} setClose={() => setJuctionModal(false)} />
    </>
  );
};

export default Triangle;
